export const PUBLIC_ASSET_START_WITH = 'spt:';

export const ASSET_LINK_BLACKLIST: Set<string> = new Set([
  'spt:us-dollar/usd',
  'spt:euro/eur',
  'spt:british-pound/gbp',
]);
